import { observable } from "mobx";

export type InitialProps = {
  inputName: string;
  value?: string;
  mode: string;
  modeParams: unknown;
  readOnly?: boolean;
};

let store: Store | undefined;

export function getStore() {
  if (!store) {
    throw new Error("Store not initialized");
  }
  return store;
}

export function createStore(props: InitialProps) {
  store = new Store(props);
}

class Store {
  readonly inputName: string;
  readonly mode: string;
  readonly modeParams: unknown;
  readonly readOnly: boolean;
  @observable accessor value = "";

  constructor(props: InitialProps) {
    this.inputName = props.inputName;
    this.mode = props.mode;
    this.modeParams = props.modeParams;
    this.value = props.value ?? "";
    this.readOnly = props.readOnly ?? false;
  }
}
